import React, { useEffect, useState } from 'react';
import { fetchProfessionals } from '../api';
import CreateBlocking from './Tabs/CreateBlocking';
import './Booking.css';

function BlockingPage() {
  const [professionals, setProfessionals] = useState([]);

  useEffect(() => {
    fetchProfessionals()
      .then(data => {
        const professionalsList = Object.entries(data.config.profissionais).map(([name, details]) => ({
          name: name,
          ...details
        }));
        setProfessionals(professionalsList);
      })
      .catch(error => console.error('Error fetching professionals:', error));
  }, []);

  return (
    <div className="booking-container">
      <CreateBlocking professionals={professionals} />
    </div>
  );
}

export default BlockingPage;

